export default __webpack_public_path__ + "static/media/sucursal2.c422b471.png";